<template>
  <div v-loading="loading" class="my-evaluators">
    <div>
      <search-input
        placeholder="Поиск по ФИО"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <eval-evaluator-status-select
        v-model="filters.statuses"
        @change="filtersChanged"
        :disabled_manage_request="true"
      ></eval-evaluator-status-select>
    </div>
    <div class="addition_evaluatees-block">
      <el-table :data="evaluatees" border>
        <el-table-column prop="evaluatee.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="evaluatee.email" label="Email"></el-table-column>
        <el-table-column width="280" label="Статус">
          <template v-slot="scope">
            <span class="status" :class="scope.row.status === 'evaluated' ? 'done' : 'in_progress'">{{ scope.row.status_label }}</span>
          </template>
        </el-table-column>
        <el-table-column width="300" align="center">
          <template v-slot="scope">
            <div v-if="scope.row.status !== 'manage_request'">
              <el-button
                v-if="scope.row.status === 'pending' || (evaluation.setting && evaluation.setting.show_evaluator_answers)"
                size="mini"
                :icon="scope.row.status === 'pending' ? 'fas fa-clipboard-check' : 'fas fa-list-alt'"
                @click="evaluate(scope.row)"
              >
                {{ scope.row.status === 'pending' ? 'Оценить' : 'Смотреть' }}
              </el-button>
              <p v-else>Оценка выставлена</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <paginator
        :paginator.sync="paginator"
        use-router-query-param
        @page-changed="loadEvaluatees"
      ></paginator>

      <evaluate-evaluatee-dialog
        @refresh-my-evaluatee="refreshEvaluatee"
        ref="evaluateDialog"
        @refresh-evaluatee="loadEvaluatees"
        @refresh-eval-user="refreshEvalUser"
      >
      </evaluate-evaluatee-dialog>
    </div>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import {mapGetters} from "vuex";
import EvalEvaluatorStatusSelect from "@/modules/evaluation/components/EvalEvaluatorStatusSelect.vue";
import EvaluateEvaluateeDialog from "@/modules/evaluation/components/myEvaluation/EvaluateEvaluateeDialog.vue";

export default {
  name: "my-evaluators-table",
  components: {EvalEvaluatorStatusSelect, EvaluateEvaluateeDialog, SearchInput, Paginator},
  data() {
    return {
      loading: false,
      evaluatees: [],
      filters: {},
    }
  },
  props: {
    evaluation: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
  },
  mixins: [paginator],
  mounted() {
    this.loadEvaluatees();
  },
  computed:{
    ...mapGetters(['user'])
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  methods: {
    loadEvaluatees() {
      this.loading = true;
      this.$api.evaluation.evaluatorsSearch({
        ...this.filters,
        types: [this.type],
        evaluation_id: this.$route.params.id,
        evaluator_id: this.user.id,
        sort: 'evaluatee.full_name',
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.evaluatees = data.evaluators;
          this.paginatorFill(paginator);
          this.$emit("update-total-count", data.byTypeEvaluatorsInfo);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    evaluate(evaluatee) {
      this.$refs.evaluateDialog.open(evaluatee, this.evaluation);
    },
    filtersChanged() {
      this.loadEvaluatees();
    },
    refreshEvaluatee() {
      this.$emit('refresh-evaluatee');
    },
    refreshEvalUser() {
      this.$emit('refresh-eval-user');
    },
  }
}
</script>

<style scoped lang="scss">
  .my-evaluators {
    .addition_evaluatees-block {
      margin: 25px 0;
    }

    .evaluatees .el-card {
      border: none !important;
    }

    .status {
      color: white;
      margin: 5px;
      border-radius: 10px;
      padding: 5px 10px;
      text-transform: uppercase;
      font-size: 12px;
      font-weight: bold;
    }

    .status.done {
      background-color: #64d074;
    }

    .status.in_progress {
      background-color: #f3ae7b;
    }
  }
</style>